import {useLocation} from "@reach/router";

export const useClickId = () => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)

  const facebookClickId = params.get('fbclid')
  const googleClickId = params.get('gclid')

  if (facebookClickId) sessionStorage.setItem('facebookClickId', facebookClickId)
  if (googleClickId) sessionStorage.setItem('googleClickId', googleClickId)
}
